<h2
  class="nes-text-inverse-subdued nes-text-center nes-font-bold nes-text-1000 nes-mb-5"
>
  {{ "ADVICE.PRODUCT_COMPARISON.HEADER" | translate }}
</h2>
@if (isMobileView) {
  <div class="nes-mb-5 nes-w-full nes-flex nes-justify-center">
    <nes-tabs>
      <div slot="buttons">
        <nes-tab-button
          *ngFor="let name of getProductNames(); let i = index"
          (click)="onSelectProduct(i)"
        >
          <p class="nes-text-inverse-subdued nes-text-400">
            {{ name }}
          </p></nes-tab-button
        >
      </div>
    </nes-tabs>
  </div>
} @else {
  <div class="nes-flex nes-py-4 nes-gap-4 nes-ml-8">
    <div
      class="nes-flex-1 nes-text-center"
      *ngFor="let key of getProductNames()"
    >
      <nes-heading
        transform="capital"
        tag="h3"
        size="800"
        color="text-inverse-subdued"
      >
        {{ key }}
      </nes-heading>
    </div>
  </div>
}

<div *ngFor="let featureGroup of featureGroups" class="custom-expandable">
  <nes-expandable
    inverted
    class="nes-bg-secondary-default nes-rounded-container nes-mb-4 nes-px-10 nes-relative"
  >
    <div
      slot="heading"
      class="nes-my-2 nes-flex nes-w-full nes-text-inverse-subdued"
    >
      <div
        class="nes-flex nes-justify-between nes-items-center nes-w-full nes-grow-0"
      >
        <div class="nes-text-inverse-subdued nes-text-">
          {{
            "PRODUCTS.FEATURE_GROUP_LABELS." + featureGroup.toUpperCase()
              | translate
          }}
        </div>
      </div>
      <div
        class="nes-hidden md:nes-inline-block nes-absolute nes-right-10 nes-bg-secondary-default nes-text-400"
      >
        {{ "ADVICE.PRODUCT_COMPARISON.SHOW_DETAILS" | translate }}
      </div>
    </div>

    @if (!isMobileView) {
      <div
        class="nes-flex nes-py-4"
        *ngFor="let key of getFeatureKeys(featureGroup)"
      >
        <div
          class="nes-flex nes-flex-1 nes-text-center"
          *ngFor="let product of allProducts"
        >
          <ng-container
            *ngTemplateOutlet="
              featureItem;
              context: {
                product: product,
                key: key,
                group: featureGroup,
                metadata: getFeatureMetadata(featureGroup, key),
              }
            "
          ></ng-container>
        </div>
      </div>
    } @else {
      <div
        *ngFor="
          let key of getFeatureKeysForMobile(
            featureGroup,
            allProducts[selectedProductIndex]
          )
        "
        class="nes-flex nes-py-2"
      >
        <div class="nes-flex nes-flex-1 nes-text-center">
          <ng-container
            *ngTemplateOutlet="
              featureItem;
              context: {
                product: allProducts[selectedProductIndex],
                key: key,
                group: featureGroup,
                metadata: getFeatureMetadata(featureGroup, key),
              }
            "
          ></ng-container>
        </div>
      </div>
    }
  </nes-expandable>
</div>

<ng-template
  #featureItem
  let-product="product"
  let-key="key"
  let-group="group"
  let-metadata="metadata"
>
  <nes-text-list-item
    [list-type]="
      product.features[group]?.[key]?.required ? 'checked' : 'unchecked'
    "
  >
    <nes-text
      [ngClass]="!product.features[group]?.[key]?.required ? 'nes-ml-10' : ''"
      [color]="
        product.features[group]?.[key]?.required
          ? 'text-inverse-subdued'
          : 'info-subdued'
      "
    >
      <div class="nes-flex nes-items-start nes-gap-7 nes-text-left">
        <nes-icon
          name="check-thick"
          size="16"
          *ngIf="product.features[group]?.[key]?.required"
        ></nes-icon>
        <div class="nes-flex nes-flex-col nes-gap-1">
          <div class="nes-flex">
            <ng-container *ngIf="metadata?.labelKey as labelKey">
              <ng-container *ngIf="labelKey | translate as label">
                <p
                  [ngClass]="
                    product.features[group]?.[key]?.required
                      ? 'nes-text-inverse-subdued'
                      : 'info-subdued'
                  "
                  class="nes-mr-2 nes-text-400"
                >
                  {{ label && label !== labelKey ? label : labelKey }}
                </p>
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="
                product.features[group]?.[key]?.required &&
                metadata?.infoTextKey as infoTextKey
              "
            >
              <ng-container *ngIf="infoTextKey | translate as infoText">
                <nes-tooltip
                  [nesId]="'nesid'"
                  icon-color="text-inverse-subdued"
                  label="label"
                >
                  <p
                    class="nes-m-0 nes-text-inverse-subdued nes-text-200"
                    *ngIf="infoText && infoText !== infoTextKey"
                  >
                    {{ infoText }}
                  </p>
                </nes-tooltip>
              </ng-container>
            </ng-container>
          </div>
          <ng-container
            *ngIf="
              product.features[group]?.[key]?.required &&
              metadata?.subLabelKey as subLabelKey
            "
          >
            <ng-container *ngIf="subLabelKey | translate as subLabel">
              <p
                class="nes-m-0 nes-text-inverse-subdued nes-text-300"
                *ngIf="subLabel && subLabel !== subLabelKey"
              >
                {{ subLabel }}
              </p>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </nes-text>
  </nes-text-list-item>
</ng-template>

<div
  class="request-product-container nes-bg-secondary-default nes-rounded nes-mb-16 nes-p-8 nes-w-full"
>
  @if (!isMobileView) {
    <div class="nes-flex">
      <div
        class="nes-flex-1 nes-text-inverse-subdued nes-items-center nes-justify-center"
        *ngFor="let name of getProductNames(); let i = index"
      >
        @if (
          ("PRODUCTS." + name.toUpperCase() + ".PRICE" | translate) === "Gratis"
        ) {
          <div class="nes-text-800 nes-font-bold nes-m-0 nes-p-0">
            {{ "PRODUCTS." + name.toUpperCase() + ".PRICE" | translate }}
          </div>
          <p class="nes-text-inverse-subdued nes-mb-5">
            {{ "ADVICE.USER_PER_MONTH" | translate }}
          </p>
          <nes-button
            (nesOnClick)="orderProduct.emit(name)"
            [variant]="advicedProduct.name === name ? 'brand' : 'primary'"
            >{{
              "ADVICE.BUTTON.ORDER_PRODUCT." + name.toUpperCase() | translate
            }}</nes-button
          >
        } @else {
          <div class="nes-my-1">
            <nes-price
              color="text-inverse-subdued"
              minimum-fraction-digits="2"
              [price]="'PRODUCTS.' + name.toUpperCase() + '.PRICE' | translate"
            ></nes-price>
          </div>
          <p class="nes-text-inverse-subdued nes-mb-5">
            {{ "ADVICE.USER_PER_MONTH" | translate }}
          </p>
          <nes-button
            (nesOnClick)="orderProduct.emit(name)"
            [variant]="advicedProduct.name === name ? 'brand' : 'primary'"
            >{{
              "ADVICE.BUTTON.ORDER_PRODUCT." + name.toUpperCase() | translate
            }}</nes-button
          >
        }
      </div>
    </div>
  } @else {
    @if (
      ("PRODUCTS." +
        allProducts[selectedProductIndex].name.toUpperCase() +
        ".PRICE" | translate) === "Gratis"
    ) {
      <p class="nes-text-800 nes-text-inverse-subdued nes-font-bold">
        {{
          "PRODUCTS." +
            allProducts[selectedProductIndex].name.toUpperCase() +
            ".PRICE" | translate
        }}
      </p>
      <p class="nes-text-inverse-subdued nes-mb-5">
        {{ "ADVICE.USER_PER_MONTH" | translate }}
      </p>
      <nes-button
        (nesOnClick)="orderProduct.emit(allProducts[selectedProductIndex].name)"
        variant="brand"
        >{{
          "ADVICE.BUTTON.ORDER_PRODUCT." +
            allProducts[selectedProductIndex].name.toUpperCase() | translate
        }}</nes-button
      >
    } @else {
      <nes-price
        color="text-inverse-subdued"
        minimum-fraction-digits="2"
        [price]="
          'PRODUCTS.' +
            allProducts[selectedProductIndex].name.toUpperCase() +
            '.PRICE' | translate
        "
      ></nes-price>
      <p class="nes-text-inverse-subdued nes-mb-5">
        {{ "ADVICE.USER_PER_MONTH" | translate }}
      </p>
      <nes-button
        (nesOnClick)="orderProduct.emit(allProducts[selectedProductIndex].name)"
        variant="brand"
        >{{
          "ADVICE.BUTTON.ORDER_PRODUCT." +
            allProducts[selectedProductIndex].name.toUpperCase() | translate
        }}</nes-button
      >
    }
  }
</div>
